import React, { Fragment } from 'react';
import './BodyContacts.scss';
import { CLFeature } from '../Components/CLFeature';

export const BodyContacts = ({ baseImgUrl }) => {
  return (
    <Fragment>
      <div className="body-contacts__main">
        <div className="body-contacts__cl-products">
          <img
            alt="Contact Lenses prooduct banner"
            preserveAspectRatio="none"
            src={`${baseImgUrl}/cl-products-banner.webp`}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              position: 'relative',
              zIndex: 2,
            }}
          />
          <div className="body-contacts__cl-products__content">
            <h1>
              Contact lens
              <br />
              starting @ $30!
            </h1>
            <button
              onClick={() => {
                window.location.href = '/sg/en/contacts/clear-contactlens';
              }}
            >
              SHOP NOW
            </button>
          </div>
        </div>
      </div>
      <CLFeature />
    </Fragment>
  );
};
